export * from '@primeuix/themes/aura/slider';
export { default } from '@primeuix/themes/aura/slider';
